export const TTS_SID = '34502';

const TTS_API_HOST = 'https://mbd.baidu.com';

export const TTS_APIS = {
    GET_VOICE_LIST: TTS_API_HOST + '/newspage/api/getpcvoicelist',
    EDIT_VOICE_LIST: TTS_API_HOST + '/newspage/api/updateuservoice',
    GET_SOURCE: TTS_API_HOST + '/newspage/api/getttsurllist'
};
